import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  title: {
    id: 'manage-services.services.schedule-increments.title',
    defaultMessage: 'Scheduling Increments',
  },
  cardTitle: {
    id: 'manage-services.services.schedule-increments.card-title',
    defaultMessage: 'Set your starting times',
  },
  descriptionFirstParagraph: {
    id: 'manage-services.services.schedule-increments.description-first-paragraph',
    defaultMessage:
      "Scheduling Increments help you select the specific appointment times shown to ClassPass users. When a value is selected below, you're allowing ClassPass users to book at these times unless restricted by your practitioner's or equipment's availability. The unchecked times for each service will not be available to book for users.",
  },
  descriptionSecondParagraph: {
    id: 'manage-services.services.schedule-increments.description-second-paragraph',
    defaultMessage:
      "<strong>Note:</strong> While a scheduling increment could be selected below, they will only be available to book if they fall within your practitioner's or equipment's availability. Additionally, these times will also be made unavailable if you have a staff block or CalendarSync block against your practitioner or equipment. <a>Learn more...</a>",
  },
  selectServiceLabel: {
    id: 'manage-services.services.schedule-increments.select-service-label',
    defaultMessage: 'Select service',
  },
  allServicesSelected: {
    id: 'manage-services.services.schedule-increments.all-services-selected',
    defaultMessage: 'All selected',
  },
  xServicesSelected: {
    id: 'manage-services.services.schedule-increments.x-services-selected',
    defaultMessage: '{count, plural, one {# selected} other {# selected}}',
  },
  clearSelection: {
    id: 'manage-services.services.schedule-increments.clear-selection',
    defaultMessage: 'Clear selection',
  },
  changesDelayCopy: {
    id: 'manage-services.services.schedule-increments.changes-delay-copy',
    defaultMessage: 'Changes can take up to 30 mins to reflect on the ClassPass app',
  },
});

export const resetModalMessages = defineMessages({
  title: {
    id: 'manage-services.services.schedule-increments.reset-modal.title',
    defaultMessage: 'Clear selection',
  },
  body: {
    id: 'manage-services.services.schedule-increments.reset-modal.body',
    defaultMessage:
      'After clicking "Clear" the selected services and start times will be cleared. Would you like to clear selection?',
  },
  accept: {
    id: 'manage-services.services.schedule-increments.reset-modal.accept',
    defaultMessage: 'Clear',
  },
  cancel: {
    id: 'manage-services.services.schedule-increments.reset-modal.cancel',
    defaultMessage: 'Cancel',
  },
});

export const updateIncrementsConfirmationModalMessages = defineMessages({
  title: {
    id: 'manage-services.services.schedule-increments.confirmation-modal.title',
    defaultMessage: 'Confirm your choice',
  },
  services: {
    id: 'manage-services.services.schedule-increments.confirmation-modal.services',
    defaultMessage: 'Services',
  },
  increments: {
    id: 'manage-services.services.schedule-increments.confirmation-modal.increments',
    defaultMessage: 'Increments',
  },
  cancel: {
    id: 'manage-services.services.schedule-increments.confirmation-modal.cancel',
    defaultMessage: 'Cancel',
  },
  confirm: {
    id: 'manage-services.services.schedule-increments.confirmation-modal.confirm',
    defaultMessage: 'Confirm',
  },
});
